export const debounce = (func: any, timeout = 700) => {
    let timer: any
    return (...args: any) => {
        clearTimeout(timer)
        timer = setTimeout(() => { func.apply(this, args) }, timeout)
    }
}